define('../app/fukit/behavior/show.detail.on.event.behavior',['require','exports','module','underscore','backbone','marionette','../helpers/route.helper','./navigate.on.event.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Backbone                = require('backbone'),
      Mn                      = require('marionette'),
      RouteHelper             = require('../helpers/route.helper'),
      NavigateOnEventBehavior = require('./navigate.on.event.behavior');

  module.exports = NavigateOnEventBehavior;
});

